import React from "react";

function HeroSection({ baseURL }) {
    // Retrieve baseURL and other necessary data using props or context

    return (
        <div className="heroSection">
            <img src={`${baseURL}/web/sites/default/files/portfolio/Exterior.webp`} alt="Elegant Finish Painting - Our work" loading="lazy" />
        </div>
    );
}

export default HeroSection;
